export const lineLink = `
  query {
    lineLink {
      email
    }
  }
`;
